import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
    root: {},
    typeFile: {
        width: '30px',
        height: '18px',
        position: 'absolute',
        top: '17px',
        left: '-4px',
        color: '#fff',
        fontSize: '11px',
        lineHeight: '20px',
        borderRadius: '4px',
        textAlign:'center',
      },
    title: {
        color: theme.palette.gray[5],
    },
    uploadIcon: {
        width: '35px',
        height: '35px',
        textAlign: 'center',
        //lineHeight: '30px',
        borderRadius: '8px',
        border: '2px solid #EEF0F2',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    titleNotFile: {
        color: '#0369CD' , 
        cursor:'pointer'
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },

    titleBox: {
        marginLeft: '8px',
        fontSize: '13px',
        display: 'flex'
    },
    chipBlock: {
        maxWidth: '460px',
        width: '460px',
        padding: '10px 0 0 !important',
        textAlign: 'center',
        '@media(max-width: 600px)': {
            maxWidth: '100%',
        },
        cursor: 'pointer'
    },
    chips: {
        marginBottom: 8,
        width: '100%',
        height: '80px',
        display: 'inline-flex',
        justifyContent: ' space-between',
        backgroundColor: '#fff',
        borderRadius: ' 10px',
        border: '2px solid #E2E5E9',
        padding: '0 10px',

        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
        '&:focus': {
            backgroundColor: '#fff',
        },
        '&:hover': {
            backgroundColor: '#fff',
        },
        '& .MuiChip-label': {
            display: 'flex',
            gap: '10px',
        },
        '& .MuiInputLabel': {
            width: '88%',
            paddingLeft: 0,
            fontSize: 12,
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            width: '100%',
            whiteSpace: 'nowrap',
            display: 'flex',
            gap: '10px',
        },
        '& .MuiTypography-root': {
            fontSize: 12,
            textAlign: 'left',
            fontWeight: '500 !important',
            margin: '5px 0',
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            justifyContent: 'center',
            '& .volume': {
                fontSize: 11,
                color: '#9AA6B1',
                fontWeight: '100 !important',
            },
        },
    },
    titleIcon: {
        fontSize: 18,
        marginInlineStart: theme.spacing(2),
    },
    download: {
        color: '#fff',
        background: '#0D1C6A',
        cursor: 'pointer',
        display: 'inline-block',
        padding: ' 4px 12px ',
        fontSize: '12px',
        borderRadius: '20px',
        margin: '3px 10px 0',
    },
    titleText: {
        fontSize: 14,
        marginInlineStart: theme.spacing(1),
        paddingTop: theme.spacing(0.5),
        fontWeight: 'bold',
    },
    docItemsContainer: {
        marginTop: theme.spacing(1),
    },
    stepperAction: {
        color: theme.palette.primary.main,
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    submitButton: {
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        [theme.breakpoints.down('lg')]: {
            width: '100%',
        },
    },
    containerSub: {
        display: 'flex',
        justifyContent: 'flex-end',
    },

    btnEvent: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginTop: '16px',
        borderTop: '1px solid #e0e0e0',
        paddingTop: '16px',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    },
    btnChangeStep: {
        marginBottom: 16,
        display: 'flex',
    },
    chipBlock: {
        marginTop: 15,
        padding: '0 20px 0 10px',
    },
    fileType: {
        width: '36px',
        position: 'relative',
        top: '5px',
    },
    chip: {
        marginBottom: 8,
        marginInlineEnd: 5,
        width: '49%',
        display: 'inline-flex',
        justifyContent: ' space-between',
        backgroundColor: theme.palette.primary.lighter,
        gap: '15px',
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
        '&:focus': {
            backgroundColor: theme.palette.primary.light,
        },
        '&:hover': {
            backgroundColor: theme.palette.primary.light,
        },
        '&.MuiInputLabel': {
            // clipPath: 'content-box',
            width: '88%',
        },
    },
}));